import { type KeyboardEvent } from 'react';

export const submitOnEnter = (action: () => void) => (event: KeyboardEvent<HTMLInputElement>) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    action();
  }
};
